export const OTHER_TEXT_ERROR = "Text response is required for 'Other'";
export const CONFIRMATION_MESSAGE = "Confirm to Save Feedback or Cancel to Edit feedback";
export const SUCCESS_MESSAGE = "Your feedback has been changed successfully. Please click OK to continue.";